<div class="card dialog-box">
  @if (title) {
    <div class="card-header">
      {{ title }}
      <span class="float-end" (click)="onDismiss()"
        ><i class="fa-solid fa-xmark"></i
      ></span>
    </div>
  }
  <div>
    @if (customTemplate) {
      <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
    }
    @if (message) {
      <div>
        <div class="alert gt-multi-line" [ngStyle]="messageStyle">
          {{ message }}
        </div>
      </div>
    }
    @if (confirmation) {
      <div>
        <div class="text-center">
          To confirm, type {{ randomNumber }} in the field:
        </div>
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          placeholder="{{ randomNumber }}"
          [(ngModel)]="confirmNumber"
          class="form-control"
          autofocus
        />
      </div>
    }
    <div class="row row-cols-2 mt-2">
      <div class="col">
        <button
          (click)="onDismiss()"
          type="button"
          class="btn btn-lg w-100"
          [ngClass]="btn1Detail?.class ? btn1Detail?.class : 'btn-secondary'"
        >
          {{ btn1Detail?.text ? btn1Detail?.text : "Cancel" }}
        </button>
      </div>
      <div class="col">
        <button
          (click)="onConfirm()"
          [disabled]="confirmation ? randomNumber != confirmNumber : false"
          class="btn btn-lg w-100"
          [ngClass]="btn2Detail?.class ? btn2Detail?.class : 'btn-primary'"
          type="button"
        >
          {{ btn2Detail?.text ? btn2Detail?.text : "Confirm" }}
        </button>
      </div>
    </div>
  </div>
</div>
